import { render, staticRenderFns } from "./match-details-modal-table.vue?vue&type=template&id=ab9e9948&scoped=true&"
import script from "./match-details-modal-table.vue?vue&type=script&lang=ts&"
export * from "./match-details-modal-table.vue?vue&type=script&lang=ts&"
import style0 from "./match-details-modal-table.vue?vue&type=style&index=0&id=ab9e9948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9e9948",
  null
  
)

export default component.exports